import { concatBuffers } from './utils/byteUtils';
import { noop } from './utils/functionUtils';
/**
 * Read bytes from a ReadableStream until the end of the stream.
 * Returns the bytes if collectStreamBody is true, otherwise returns undefined.
 */
export async function readBytesFromStream(stream, options) {
    const reader = stream.getReader();
    const chunks = [];
    while (true) {
        const result = await reader.read();
        if (result.done) {
            break;
        }
        if (options.collectStreamBody) {
            chunks.push(result.value);
        }
    }
    reader.cancel().catch(
    // we don't care if cancel fails, but we still need to catch the error to avoid reporting it
    // as an unhandled rejection
    noop);
    return options.collectStreamBody ? concatBuffers(chunks) : undefined;
}
//# sourceMappingURL=readBytesFromStream.js.map